import { useLocation } from 'react-router';
import { useMemo } from 'react';

export enum CampaignEditorTab {
  Audience = 'audience',
  Content = 'content',
  Scheduling = 'scheduling',
}

export const useActiveTab = (): CampaignEditorTab => {
  const location = useLocation();

  const activeTab = useMemo(() => {
    const tabs = {
      audience: CampaignEditorTab.Audience,
      content: CampaignEditorTab.Content,
      scheduling: CampaignEditorTab.Scheduling,
    };

    let found: CampaignEditorTab;
    Object.keys(tabs).some(k => {
      if (location.pathname.toLowerCase().search(k) !== -1) {
        found = tabs[k];
        return true;
      }

      return false;
    });

    return found;
  }, [location.pathname]);

  return activeTab;
};
